import React, { FC } from "react";
import { Tabs as AntdTabs } from "antd";

import InstrumrntTradingVolumes from "./InstrumrntTradingVolumes";
import InstrumentVolatility from "./InstrumentVolatility";
import InstrumentHistoricalChart from "./InstrumentHistoricalChart";

const { TabPane } = AntdTabs;

const InstrumentTabs: FC = () => {
  return (
    <AntdTabs defaultActiveKey="1">
      <TabPane tab="Historical chart" key="1">
        <InstrumentHistoricalChart />
      </TabPane>
      <TabPane tab="Volatility" key="2">
        <InstrumentVolatility />
      </TabPane>
      <TabPane tab="Trading Volumes" key="3">
        <InstrumrntTradingVolumes />
      </TabPane>
    </AntdTabs>
  );
};

export default InstrumentTabs;
